// react
import { useEffect, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// fields
import { Select, SelectProps } from '../Select/Select';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// types
import { Option } from '../../../@types';

// ui
import { Flag } from '../../ui/Flag/Flag';

// utils
import { flagsByCurrency } from '../../../utils/currency';
import { defaultCurrencies } from '../../../utils/defaults';

export type SelectCurrencyProps = {
	currencies?: string[];
	disabledCurrencies?: string[];
	hasLabel?: boolean;
} & SelectProps;

export const SelectCurrency = ({
	currencies: currenciesProp,
	disabledCurrencies = [],
	hasLabel = true,
	hasNoneOption = false,
	...props
}: SelectCurrencyProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [currencies, setCurrencies] = useState<string[]>(currenciesProp || defaultCurrencies);

	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	useFetch({
		isEnabled: Boolean(!currenciesProp),
		url: `${process.env.REACT_APP_API_URL}/api/proxies/currencies`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data.length) {
				setCurrencies(res.data);
			}
		},
	});

	const optionsCurrency: Option[] = currencies.map((currency) => {
		return {
			disabled: disabledCurrencies.includes(currency),
			icon: flagsByCurrency[currency] ? <Flag code={flagsByCurrency[currency]} /> : undefined,
			label: currency,
			value: currency,
		};
	});

	// set currencies when currencies prop changes
	useEffect(() => {
		if (currenciesProp) {
			setCurrencies(currenciesProp);
		}
	}, [currenciesProp]);

	return (
		<Select
			{...props}
			aria-label={hasLabel ? undefined : t('currency')}
			hasNoneOption={hasNoneOption}
			label={hasLabel ? props.label || t('currency') : undefined}
			options={optionsCurrency}
		/>
	);
};
